import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './transferenciaForm';
import FormatUtils from '../common/formatUtils/FormatUtils';
import Aguardando from '../common/template/aguardando';
import pdfAdd from '../assets/images/icone_add_pdf.png';

import { 
	getListaDescargaBase, alterarDescargaBase
} from './transferenciaActions';
import { 
	getLista as getListaBloqueioBase
} from '../bloqueioBase/bloqueioBaseActions';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import consts from '../consts';
import Camera from '../common/camera/camera';
import { setError } from '../common/toast/toast';

class TransferenciaBase extends Component {

	state = {
		linhaSelecionada: null,
		scrollY: -1
	}

    componentWillMount() {
		this.props.getListaDescargaBase();
		this.props.getListaBloqueioBase();

		let idInterval = setInterval(() => {
			this.props.getListaDescargaBase();
			this.props.getListaBloqueioBase();
		}, 60000);
		
		this.setState({
			...this.state,
			idInterval: idInterval
		});
	}
	
	componentWillUnmount() {

		if (this.state.idInterval) {
			clearInterval(this.state.idInterval);
		}
	
    }

    render() {

        return (
            <div>
                <Content>
					
					<Aguardando aguardando={this.props.aguardando} />

					{this.lista()}
					
                </Content>
            </div>
        )
    }

	lista() {

		if (this.state.eventoTirarFoto) {
			
			if (this.state.scrollY == -1) {
				this.setState({
					...this.state,
					scrollY: window.scrollY
				});
			}

			return <Camera eventoFoto={this.state.eventoTirarFoto} />
		}

		if (this.state.scrollY > -1) {
			const scrollY = this.state.scrollY;
			setTimeout(() => {
				window.scrollTo(0, parseInt(scrollY));
			}, 20);

			this.setState({
				...this.state,
				scrollY: -1
			});
		}

		if (this.props.telaBloqueada) {
			return (
				<div class='alert alert-danger alert-dismissible'>
					<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>×</button>
					<h5><i class='icon fas fa-ban'></i> Base Bloqueada!</h5>
					Aguarde! A base está bloqueada pois passa por auditoria.
				</div>
			);
		}

		return (
			<>
				
				{this.eventoComponenteNumerico()}
				
				{!this.props.lista.length &&
				<p style={{ fontWeight: 'bold', textAlign: 'center', marginTop: 40 }}>Nenhuma viagem encontrada</p>}
				{this.props.lista.filter(item => {
					//Só lista uma viagem por vez
					if (this.props.lista.filter(itemAux => itemAux.datahora_inicio_descarga).length && !item.datahora_inicio_descarga) {
						return false;
					}
					return true;
				}).map(item => {

					return (
						<ContentCard key={item.id} style={{ backgroundColor: '#ffffff' }}>
							<ContentCardHeader>
								<Row>
									<Grid cols='12 12 12 12'>
										<strong>Base:</strong> {item.nome_unidade_origem}
									</Grid>
									<Grid cols='12 12 12 12'>
										<strong>Distribuidora:</strong> {item.nome_distribuidora}
									</Grid>
									<Grid cols='12 12 12 12'>
										<strong>Placa:</strong> {item.placa_veiculo}
									</Grid>
									<Grid cols='12 12 12 12'>
										<strong>Motorista:</strong> {item.nome_motorista}
									</Grid>
									<Grid cols='12 12 12 12'>
										<strong>Nota Fiscal:</strong> {item.numero_nfe}
									</Grid>
									<Grid cols='12 12 12 12'>
										<strong>Itens:</strong>
									</Grid>
								</Row>

								{(item.itens || []).filter(transferenciaItem => transferenciaItem.ativo).map((transferenciaItem, i) => (
									<Row key={transferenciaItem.id} style={{ backgroundColor: i % 2 == 0 ? '#f2f5f3' : '#e0e0e0' }}>
										<Grid cols='6 6 6 6'>
											{transferenciaItem.nome_produto}
										</Grid>
										<Grid cols='6 6 6 6' style={{ textAlign: 'right' }}>
											{FormatUtils.formatarValorTelaDecimal(transferenciaItem.quantidade, 2)} L
										</Grid>
									</Row>
								))}


								
								{item.datahora_inicio_descarga &&
								<>
									<Row>
										{this.componenteImagem(
											'Foto da Frente:',
											item.descarga_imagem_frente || [],
											(arquivos) => {
												this.props.alterarDescargaBase({
													...item,
													descarga_imagem_frente: arquivos
												});
											}
										)}
									</Row>

									<Row>
										{this.componenteImagem(
											'Foto do Calço:',
											item.descarga_imagem_calco || [],
											(arquivos) => {
												this.props.alterarDescargaBase({
													...item,
													descarga_imagem_calco: arquivos
												});
											}
										)}
									</Row>
									
									<Row>
										{this.componenteImagem(
											'Foto do Aterramento:',
											item.descarga_imagem_terra || [],
											(arquivos) => {
												this.props.alterarDescargaBase({
													...item,
													descarga_imagem_terra: arquivos
												});
											}
										)}
									</Row>
									
									<Row>
										{this.componenteImagem(
											'Foto da Nota Fiscal:',
											item.descarga_imagem_nf || [],
											(arquivos) => {
												this.props.alterarDescargaBase({
													...item,
													descarga_imagem_nf: arquivos
												});
											}
										)}
									</Row>
									
									<Row>
										{this.componenteImagem(
											'Foto da Proveta:',
											item.descarga_imagem_proveta || [],
											(arquivos) => {
												this.props.alterarDescargaBase({
													...item,
													descarga_imagem_proveta: arquivos
												});
											}
										)}
									</Row>
									
									<Row>
										{this.componenteImagem(
											'Foto do Lacre:',
											item.descarga_imagem_lacre || [],
											(arquivos) => {
												this.props.alterarDescargaBase({
													...item,
													descarga_imagem_lacre: arquivos
												});
											}
										)}
									</Row>
									 
									<Row>
										{this.componenteImagem(
											'Foto do Dreno:',
											item.descarga_imagem_dreno || [],
											(arquivos) => {
												this.props.alterarDescargaBase({
													...item,
													descarga_imagem_dreno: arquivos
												});
											}
										)}
									</Row>
									 
									<Row>
										{this.componenteImagem(
											'Foto da Seta:',
											item.descarga_imagem_seta || [],
											(arquivos) => {
												this.props.alterarDescargaBase({
													...item,
													descarga_imagem_seta: arquivos
												});
											}
										)}
									</Row>

									<Row>
										{this.componenteImagem(
											'Foto Proveta / Densidade / Temperatura:',
											item.descarga_imagem_qualidade || [],
											(arquivos) => {
												this.props.alterarDescargaBase({
													...item,
													descarga_imagem_qualidade: arquivos
												});
											}
										)}
									</Row>

									<Row>
										{this.componenteNumerico(
											`Temperatura:`,
											(item.descarga_temperatura || [])[0],
											(valor) => {
												this.props.alterarDescargaBase({
													...item,
													descarga_temperatura: [{
														valor: valor
													}]
												});
											},
											1 //Casas Decimais
										)}
									</Row>
									
									<Row>
										{this.componenteNumerico(
											`Densidade:`,
											(item.descarga_densidade || [])[0],
											(valor) => {
												this.props.alterarDescargaBase({
													...item,
													descarga_densidade: [{
														valor: valor
													}]
												});
											},
											2 //Casas Decimais
										)}
									</Row>

									<Row>
										{this.componenteNumerico(
											`Quantidade S10:`,
											(item.descarga_quantidade_s10 || [])[0],
											(valor) => {
												this.props.alterarDescargaBase({
													...item,
													descarga_quantidade_s10: [{
														valor: valor
													}]
												});
											},
											0 //Casas Decimais
										)}
									</Row>

									<Row>
										{this.componenteNumerico(
											`Quantidade S500:`,
											(item.descarga_quantidade_s500 || [])[0],
											(valor) => {
												this.props.alterarDescargaBase({
													...item,
													descarga_quantidade_s500: [{
														valor: valor
													}]
												});
											},
											0 //Casas Decimais
										)}
									</Row>

								</>}


								
																
							</ContentCardHeader>

							<ContentCardBody>
								{!item.datahora_inicio_descarga ? (
									<Row alignCenter>
										<Grid cols='12 6 4 4' style={{ paddingRight: 16 }}>
											<button 
												type='button'
												class='btn btn-block btn-success btn-lg'
												onClick={() => {
													if (window.confirm('Deseja realmente iniciar descarga?')) {
														this.props.alterarDescargaBase({
															...item,
															datahora_inicio_descarga: DateFormat.getDataHoraAtual(),
															id_usuario_descarga: this.props.sessao.id
														});
													}
												}}>
												Iniciar Descarga
											</button>
										</Grid>
									</Row>
								) : (
									<div>
										<Row>
											<Grid cols='6 6 6 6'>
												<strong>Início da Descarga:</strong>
											</Grid>
										</Row>
										<Row>
											<Grid cols='6 6 6 6'>
												{DateFormat.formatarDataHoraSqlParaTela(item.datahora_inicio_descarga)}
											</Grid>
										</Row>							
									</div>
								)}
								
								{(item.datahora_inicio_descarga && !item.datahora_fim_descarga) ? (
									<Row alignCenter style={{ marginTop: 16 }}>
										<Grid cols='12 6 4 4' style={{ paddingRight: 16 }}>
											<button 
												type='button'
												class='btn btn-block btn-danger btn-lg'
												onClick={() => {
													if (window.confirm('Deseja realmente desfazer o início da descarga?')) {
														this.props.alterarDescargaBase({
															...item,
															datahora_inicio_descarga: null
														});
													}
												}}>
												Desfazer Início da Descarga
											</button>
										</Grid>
										<Grid cols='12 6 4 4' style={{ paddingRight: 16 }}>
											<button 
												type='button'
												class='btn btn-block btn-success btn-lg'
												onClick={() => {
													if (window.confirm('Deseja realmente finalizar descarga?')) {
														this.props.alterarDescargaBase({
															...item,
															datahora_fim_descarga: DateFormat.getDataHoraAtual()
														});
													}
												}}>
												Finalizar Descarga
											</button>
										</Grid>
									</Row>
								) : (item.datahora_fim_descarga ? (
									<div>
										<Row>
											<Grid cols='6 6 6 6'>
												<strong>Fim da Descarga:</strong>
											</Grid>
										</Row>
										<Row>
											<Grid cols='6 6 6 6'>
												{DateFormat.formatarDataHoraSqlParaTela(item.datahora_fim_descarga)}
											</Grid>
										</Row>
										<br />
										<Row alignCenter>
											<Grid cols='12 6 4 4' style={{ paddingRight: 16 }}>
												<button 
													type='button'
													class='btn btn-block btn-danger btn-lg'
													onClick={() => {
														if (window.confirm('Deseja realmente reabrir a descarga?')) {
															this.props.alterarDescargaBase({
																...item,
																datahora_fim_descarga: null
															});
														}
													}}>
													Reabrir Descarga
												</button>
											</Grid>
										</Row>
									</div>
								) : null)}
								
							</ContentCardBody>
						</ContentCard>
					);
				})}
			</>
		);
    }

	componenteImagem(nome, arquivos, evento) {

		return (
				<Grid cols='12 12 12 12'>
					<Row style={{ paddingBottom: 8 }}>
						<Grid cols='12 12 12 12'>
							<label>{nome} <i class={(arquivos || []).length ? `fas fa-check-double` : 'fas fa-exclamation-triangle'} style={{ color: (arquivos || []).length ? '#00a13b' : '#ff0000' }}></i></label>
						</Grid>
						{(arquivos || []).map(arquivo => (
							<div key={arquivo.id} style={{ marginLeft: 8, display: 'flex', flexDirection: 'column' }}>
								<span class="btn btn-outline-primary fileinput-button dz-clickable">
									<img src={arquivo.arquivo_base64 ? arquivo.arquivo_base64 : (arquivo.file ? `${consts.URL}/${arquivo.file}` : pdfAdd)} style={{ height: 30 }} />
								</span>
								<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingRight: 2, marginTop: 4 }}>
									<button
										type='button'
										class='btn btn-flat btn-outline-primary'
										style={{ width: '48%' }}
										disabled={arquivo.arquivo_base64 ? true : false}
										onClick={() => {
											window.open(`${consts.URL}/${arquivo.file}`, '_blank');
										}}>
										<i class='fas fa-download'></i>
									</button>
									<button
										type='button'
										class='btn btn-flat btn-outline-danger'
										style={{ width: '48%' }}
										onClick={() => {
											evento(arquivos.filter(item => item.id != arquivo.id));
										}}>
										<i class='fas fa-trash-alt'></i>
									</button>
								</div>
							</div>
						))}
						
						<a class={`btn btn-app bg-success`}
							onClick={() => {
								this.setState({
									...this.state,
									eventoTirarFoto: (result) => {
										let lista = (arquivos || []).map(item => item);
										lista.push({
											id: new Date().getTime(),
											arquivo_base64: result
										});
										evento(lista);
										this.setState({
											...this.state,
											eventoTirarFoto: null
										});
									}
								});
							}}>
							<i class='fas fa-camera'></i> Câmera
						</a>
					</Row>
				</Grid>
		);
	}

	componenteNumerico(nome, registro, evento, casasDecimais) {

		return (
			<Grid cols='12 12 12 12'>
				<Row style={{ paddingBottom: 8 }}>
					<Grid cols='12 12 12 12'>
						<label>{nome} <i class={registro && parseFloat(registro.valor || 0) > 0.0  ? `fas fa-check-double` : 'fas fa-exclamation-triangle'} style={{ color: registro && parseFloat(registro.valor || 0) > 0.0 ? '#00a13b' : '#ff0000' }}></i></label>
					</Grid>
					<button 
						type='button'
						class='btn btn-block btn-outline-dark btn-flat'
						style={{ maxWidth: 200 }}
						onClick={() => {
							this.setState({
								...this.state,
								casasComponenteNumerico: casasDecimais || 0,
								valorComponenteNumerico: registro ? FormatUtils.formatarValorTela(registro.valor, casasDecimais) : '',
								eventoComponenteNumerico: (result) => {
									evento(result);
									this.setState({
										...this.state,
										eventoComponenteNumerico: null
									});
								}
							});
						}}>
						{registro ? FormatUtils.formatarValorTela(registro.valor, casasDecimais) : FormatUtils.formatarValorTela(0, casasDecimais)}
					</button>
				</Row>
			</Grid>
		);
	}

	eventoComponenteNumerico() {
		if (!this.state.eventoComponenteNumerico) {
			return null;
		}

		return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-md'>
					<div class='modal-content'>
						<div class='modal-header'>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' 
								onClick={() => {
									this.setState({
										...this.state,
										eventoComponenteNumerico: null
									});
								}}>
								<span aria-hidden='true'>×</span>
							</button>
						</div>
						<div class='modal-body'>
							<Row>
								<LabelAndInputNumber
									label='Informe' 
									placeholder='Informe'
									cols='12 12 12 12'
									casas={this.state.casasComponenteNumerico}
									value={this.state.valorComponenteNumerico}
									onChange={data => {
										this.setState({
											valorComponenteNumerico: data.target.value
										});
									}} />
							</Row>
						</div>
						<div class='modal-footer justify-content-between'>
							<button type='button' class='btn btn-default' data-dismiss='modal' style={{ visibility: 'hidden' }}>Close</button>
							<button type='button' class='btn btn-primary'
								onClick={() => {
									this.state.eventoComponenteNumerico(
										parseFloat(FormatUtils.formatarValorBanco(this.state.valorComponenteNumerico, this.state.casasComponenteNumerico))
									);
								}}>Salvar</button>
						</div>
					</div>
				</div>
			</div>
        );
	}
	
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.transferencia.aguardando,
	modoTela: state.transferencia.modoTela,
	lista: state.transferencia.listaTransferenciaDescargaBase.filter(item => {
		if (!state.auth.usuarioCarregado) {
			return false;
		} else if (state.auth.usuarioCarregado.id_unidade) {
			return item.id_unidade_destino == state.auth.usuarioCarregado.id_unidade;
		} else {
			return true;
		}
	}).filter(item => {
		if (item.datahora_inicio_descarga && item.id_usuario_descarga != state.auth.usuarioCarregado.id) {
			return false;
		}

		return true;
	}),
	telaBloqueada: state.auth.usuarioCarregado 
		&& state.bloqueioBase.listaBloqueada.filter(item => !state.auth.usuarioCarregado.id_unidade || item.id_unidade == state.auth.usuarioCarregado.id_unidade).length
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	getListaDescargaBase, alterarDescargaBase, getListaBloqueioBase
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(TransferenciaBase);
